//=====================================================
//　ゲスト情報
//=====================================================
import { useState } from "react";
import { IFOrder } from "./CommonConst";

//ゲスト情報管理IF
export interface IFUseOrder {
    data: IFOrder,
    setData: React.Dispatch<React.SetStateAction<IFOrder>>,
    useStart: any,
}

//初期値
export const IVOrder = {
    initial: true,
    order_name_last: "",
    order_name_first: "",
    furigana_last: "",
    furigana_first: "",
    zip: "",
    address_first: "",
    address_second: "",
    address_thirs: "",
    address_fourth: "",
    phone: "",
    email_address: "",
    parking_space_flg: "",
    first_time_flg: "",
    order_comment: "",
    reserve_date_1: "",
    reserve_date_2: "",
    reserve_date_3: "",
    reserve_start_time_1: "",
    reserve_start_time_2: "",
    reserve_start_time_3: "",
    reserve_end_time_1: "",
    reserve_end_time_2: "",
    reserve_end_time_3: "",
}

//-----------------------------------------------------
//　ゲスト情報管理
//-----------------------------------------------------
export function useOrder():IFUseOrder{

    const [data, setData] = useState<IFOrder>(IVOrder);

    //注文フォーム情報使用開始
    function useStart(){
        let tmpOrder = IVOrder;
        tmpOrder.initial = false;
    }

    return { data, setData, useStart }

}